import { LOGIN_SUCCESS } from './user'
import filterCartItemsWithActiveSubscriptions from '../lib/filterCartItems'
import { getCSRF } from './global'

export const initialState = {
  items: [],
  loading: false
}

export const ADD_TO_CART = 'ADD_TO_CART'
export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS'
export const ADD_TO_CART_ERROR = 'ADD_TO_CART_ERROR'

export const EMPTY_CART = 'EMPTY_CART'
export const EMPTY_CART_SUCCESS = 'EMPTY_CART_SUCCESS'
export const EMPTY_CART_ERROR = 'EMPTY_CART_ERROR'

export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
export const REMOVE_FROM_CART_SUCCESS = 'REMOVE_FROM_CART_SUCCESS'
export const REMOVE_FROM_CART_ERROR = 'REMOVE_FROM_CART_ERROR'

export const addToCart = subscriptionId => async (dispatch, getState, { httpRequest }) => {
  const subscriptionExistsInCart = getState().cart.items.filter(subscription => {
    return subscription.id === subscriptionId
  }).length > 0

  if (!subscriptionExistsInCart) {
    dispatch({ type: ADD_TO_CART })
    try {
      const csrf = await dispatch(getCSRF())
      const response = await httpRequest.post('/cart', { subscription_id: subscriptionId }, {
        headers: {
          'x-csrf-token': csrf.token
        }
      })
      dispatch({
        type: ADD_TO_CART_SUCCESS,
        subscription: response.data
      })
      return Promise.resolve(response.data)
    } catch (err) {
      dispatch({
        type: ADD_TO_CART_ERROR,
        error: err.response.data
      })
      return Promise.reject(err.response.data)
    }
  }
}

export const emptyCart = () => (dispatch, getState, { httpRequest }) => {
  dispatch({ type: EMPTY_CART })
  return httpRequest.delete('/cart')
    .then(() => {
      dispatch({
        type: EMPTY_CART_SUCCESS
      })
    })
}

export const removeFromCart = id => (dispatch, getState, { httpRequest }) => {
  dispatch({ type: REMOVE_FROM_CART })
  httpRequest.delete(`/cart/${id}`)
    .then(response => {
      dispatch({
        type: REMOVE_FROM_CART_SUCCESS,
        subscription: response.data
      })
    })
}

const ACTION_HANDLERS = {
  [ADD_TO_CART]: state => {
    return {
      ...state,
      loading: true
    }
  },
  [ADD_TO_CART_SUCCESS]: (state, { subscription }) => {
    return {
      ...state,
      items: isProductTypeSubscriptionAdded(state, subscription)
        ? state.items.map(item => item.product_type_id === subscription.product_type_id ? item = subscription : item)
        : [...state.items, subscription],
      loading: false
    }
  },
  [ADD_TO_CART_ERROR]: state => {
    return {
      ...state,
      loading: false
    }
  },
  [REMOVE_FROM_CART]: state => ({
    ...state,
    loading: true
  }),
  [REMOVE_FROM_CART_SUCCESS]: (state, { subscription }) => {
    return {
      ...state,
      items: state.items.filter(item => item.id !== subscription.id),
      loading: false
    }
  },
  [EMPTY_CART]: state => ({
    ...state,
    loading: true
  }),
  [EMPTY_CART_SUCCESS]: state => ({
    ...state,
    items: [],
    loading: false
  }),
  [LOGIN_SUCCESS]: (state, { user }) => {
    return {
      ...state,
      items: filterCartItemsWithActiveSubscriptions(user, state.items)
    }
  }
}

function isProductTypeSubscriptionAdded(state, subscription) {
  return state.items.filter(item => item.product_type_id === subscription.product_type_id).length > 0
}

export default function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./reducers/cart.js